// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__DJDMv","container":"Modal_container__Ha+Ky","header":"Modal_header__fOQI0","icon":"Modal_icon__2UpwH"};